import { __makeTemplateObject } from "tslib";
import styled from "styled-components";
export var Card = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 32px;\n  background: white;\n  box-shadow: 0px 4px 16px rgba(12, 12, 13, 0.1);\n  border-radius: 4px;\n"], ["\n  padding: 32px;\n  background: white;\n  box-shadow: 0px 4px 16px rgba(12, 12, 13, 0.1);\n  border-radius: 4px;\n"])));
var templateObject_1;
